<template>
  <footer class="footer" :class="page">
    <a href="/">
      <div class="logo footer__logo" role="img" aria-label="TriviaPop"></div>
    </a>
    <ul class="footer__list">
      <!--<li class="footer__item"><a href="/about" class="footer__link">About</a></li>-->
      <li class="footer__item"><a href="/terms" class="footer__link">Terms of Use</a></li>
      <li class="footer__item"><a href="/privacy" class="footer__link">Privacy Policy</a></li>
      <li class="footer__item"><a href="/unsubscribe" class="footer__link">Unsubscribe</a></li>
      <li class="footer__item"><a href="/contact" class="footer__link">Contact Us</a></li>
    </ul>
    <small class="footer__copyright">&copy; 2019 TriviaPop</small>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  props: ["page"]
};
</script>

<style scoped lang="scss">
  .footer {
    flex-shrink: 0;
    position: relative;
    width: 100%;
    padding: 5.6rem 0.8rem 3.6rem;
    @media ($small) {
      padding: 5.6rem 4.8rem 3.6rem;
    }
    @media ($medium) {
      padding-bottom: 5.4rem;
    }
    &__logo {
      @extend %small-logo;
      top: -2.7rem;
      @media ($medium) {
        width: 11.2rem;
        height: 7rem;
        top: -2.8rem;
      }
    }
    &__list {
      @extend %max-trivia-page-width;
      display: flex;
      justify-content: space-evenly;
      @media ($medium) {
        font-size: 1.4rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
    }
    &__item {
      font-weight: 500;
      margin-bottom: 1.6rem;
      @media ($medium) {
        text-align: center;
      }
      &:nth-child(even) {
        @media ($medium) {
          text-align: center;
        }
      }
    }
    &__link {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    &__copyright {
      font-size: 1.2rem;
      text-align: center;
      margin: 0;
      display: block;
    }
  }
</style>
